export default "__VITE_ASSET__rBU1aN5W__"